import { Navigate, useLocation } from "react-router-dom";

export function hasAnyRole(user, roles = []) {
    if (!roles?.length) {
        // se rota não exige role, libera
        return true;
    }

    const set = new Set(user?.autoridades.map((a) => a.authority) ?? []);

    return roles.some((r) => set.has(r));
}

export function RequireAuth({ children }) {
    if (
        localStorage.usuarioWGSol === null ||
        localStorage.usuarioWGSol === undefined ||
        localStorage.authorizationWGSolJwtToken === undefined
    ) {

        const redirectUri = encodeURIComponent(window.location.pathname + window.location.search);

        return <Navigate to={`/entrar?redirect_uri=${redirectUri}`} replace />;
    }

    return children;
}

export function RequireAccess({ roles = [], perms = [], fallback = "/acessonegado", children }) {
    const user = JSON.parse(localStorage.usuarioWGSol);
    const okRole = hasAnyRole(user, roles);

    if (!okRole) {
        return <Navigate to={fallback} replace />;
    }

    return children;
}
